// RiverHack specific colors
export const riverhackColors = {
  deepPurple: '#32286f',  // Primary color
  sandBeige: '#f6debd',   // Background accent
  vibrantOrange: '#ea542f', // Call to action
  burgundy: '#713959',    // Secondary color
  terracotta: '#c75e52',  // Accent color
  spaceBlack: '#000000',  // Pure black for maximum contrast
  cosmicWhite: '#FFFFFF', // Pure white for maximum contrast
  starField: '#111111',   // Slightly lighter than black for depth
  nasaBlue: '#0099FF',    // NASA blue for space theme
  nasaBlueDark: '#0066CC'  // Darker NASA blue for better contrast
};

export const riverhackThemeExtension = {
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: riverhackColors.sandBeige,
          color: riverhackColors.deepPurple,
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: riverhackColors.vibrantOrange,
          color: '#fff',
          '&:hover': {
            backgroundColor: riverhackColors.terracotta,
          }
        }
      }
    }
  }
}; 